import { render, staticRenderFns } from "./EkycDocument.vue?vue&type=template&id=cd7ccd36&scoped=true&"
import script from "./EkycDocument.vue?vue&type=script&lang=js&"
export * from "./EkycDocument.vue?vue&type=script&lang=js&"
import style0 from "./EkycDocument.vue?vue&type=style&index=0&id=cd7ccd36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7ccd36",
  null
  
)

export default component.exports